import { ONEGO_LOGO } from "../lib/api";

export default function Footer() {
    return (
        <footer className="mt-32 border-t border-slate-200 bg-white" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <img src={ONEGO_LOGO} alt="OneGo" className="h-10 w-auto" />
                    <p className="mt-4 text-slate-600 max-w-md">
                        OneGo is the commerce and financial operating system for Africa&rsquo;s informal economy.
                        Built merchant-first, mobile-first, offline-resilient.
                    </p>
                    <div className="mt-6 og-divider-gradient w-40" />
                </div>
                <div>
                    <p className="text-xs font-bold tracking-widest text-onego-navy uppercase">Platform</p>
                    <ul className="mt-3 space-y-2 text-slate-600 text-sm">
                        <li>Wallet</li>
                        <li>Digital services</li>
                        <li>Procurement</li>
                        <li>Merchant credit</li>
                        <li>Logistics</li>
                    </ul>
                </div>
                <div>
                    <p className="text-xs font-bold tracking-widest text-onego-navy uppercase">Company</p>
                    <ul className="mt-3 space-y-2 text-slate-600 text-sm">
                        <li>Vision</li>
                        <li>Roadmap</li>
                        <li>Investors</li>
                        <li>Careers</li>
                        <li>Contact</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-slate-200 py-6 text-center text-xs text-slate-500">
                &copy; {new Date().getFullYear()} OneGo. The operating system for informal African commerce.
            </div>
        </footer>
    );
}
